@for (group of visibleGroups$(); track groupIndex; let groupIndex = $index) {
  @if (groupIndex > 0) {
    <div class="sol-popover-group-divider"></div>
  }

  @if (!!group.name) {
    <div class="sol-popover-group-title">
      {{ group.name | translate }}
    </div>
  }

  @for (item of group.items; track itemIndex; let itemIndex = $index) {
    <sol-popover-menu-item
      [type]="item.type"
      [icon]="item.icon"
      [text]="item.name === undefined ? item.id : item.name"
      [params]="item.params"
      [autoFocus]="!passive$()"
      [hint]="item.hint"
      [shortcut]="item.shortcut"
      [disabled]="item.disabled || false"
      [selected]="item.selected || currentId$() === item.id"
      (click)="onAction(item.id)"
      (selected)="onSelected(item.id, $event)"
    ></sol-popover-menu-item>
  }
}

@if (visibleGroups$().length === 0) {
  <div class="sol-popover-menu-items-empty">
    {{ 'sol-action-bar.empty' | translate }}
  </div>
}
